<template>
  <div class="is-title-bar">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <h1 class="title">
            <slot />
            {{ translatedTrUnits }}/{{ totalTrUnits }}
          </h1>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item" v-if="translatedTrUnits != totalTrUnits">
            <b-button size="is-default"
                @click="$emit('move-tr', {direction: -1, untranslated: true})"
            >Prev</b-button>
            <b-button size="is-default"
                @click="$emit('move-tr', {direction:  1, untranslated: true})"
            >Next</b-button>
        </div>
        <div class="level-item">
            {{sourceName}} -> {{ targetName }} &nbsp;
            <b-button type="is-success" :disabled="!changeCount" @click="saveChanges">Save ({{ changeCount }})</b-button>
        </div>
      </div>
    </div>
    <b-progress type="is-success" :value="totalTranslated" :max="t9n_tags.length" show-value>
        {{ totalTranslated }} / {{ t9n_tags.length }}
    </b-progress>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions }       from 'vuex'

export default {
    name: "TrTitleBar",
    props: [ "translatedTrUnits", "totalTrUnits"],
    computed: {
        ...mapState   ("translation", {
              changeCount: state => state.changeCount,
              t9n_tags:    state => state.t9n_tags
              }),
        ...mapGetters ("translation", ["sourceName", "targetName", "totalTranslated"]),
    },
    methods: {
        ...mapActions ("translation", ["saveChanges"])
    }
}
</script>
